import { assert } from 'chai';
import httpMocks from 'node-mocks-http';

import checkPort from './checkPort';

describe('checkPort', () => {
    it('should call next() on valid port', (done) => {
        const req = httpMocks.createRequest({ body: { port: 23 } });
        const res = httpMocks.createResponse();
        checkPort(req, res, done);
    });

    it('should return 400 without port', (done) => {
        const req = httpMocks.createRequest({ body: {} });
        const res = httpMocks.createResponse();
        checkPort(req, res);
        assert.equal(400, res._getStatusCode()); // eslint-disable-line no-underscore-dangle
        done();
    });

    it('should return 400 with port above valid range', () => {
        const req = httpMocks.createRequest({ body: { port: 70000 } });
        const res = httpMocks.createResponse();
        checkPort(req, res);
        assert.equal(400, res._getStatusCode()); // eslint-disable-line no-underscore-dangle
    });

    it('should return 400 with port below valid range', () => {
        const req = httpMocks.createRequest({ body: { port: 0 } });
        const res = httpMocks.createResponse();
        checkPort(req, res);
        assert.equal(400, res._getStatusCode()); // eslint-disable-line no-underscore-dangle
    });

    // it('should return 400 with malformed port', () => {
    //     const req = httpMocks.createRequest({ body: { port: '192.168.1.1' } });
    //     const res = httpMocks.createResponse();
    //     checkPort(req, res);
    //     assert.equal(400, res._getStatusCode()); // eslint-disable-line no-underscore-dangle
    // });
});
